import { put } from '../stores';
export const FETCH_OVERLAY_POPUP = `FETCH_OVERLAY_POPUP`;
export const EMMA_BETTER_ME_POPUP = `EMMA_BETTER_ME_POPUP`;
export const EMMA_WELCOME_LAUNCH_POPUP = 'EMMA_WELCOME_LAUNCH_POPUP';
